export const dbEvents = new EventTarget();

export const emitDbChange = (store, id = null) => {
  dbEvents.dispatchEvent(new CustomEvent("dbChange", { detail: { store, id } }));
};